<template>
    <div class="body">
        <transition appear>
			<div v-if="!reportData" class="zhezhao">
				<div class="image" style="width: 100%; height: 13%">
					<img src="@/assets/24June/logo.png" style="width: 217px; height: 77px; margin-left: 7px"/>
				</div> 

				<div class="right" style="width: 100%; height: 87%">
					<p class="font1" style="font-size: 86px; margin-top: 20vh;color: #e06c24;"> 2024富学宝典</p>
					<p class="font1" style=" color: #99345d;font-size: 71px;margin-top: 20px;color: #e06c24;"> 半年度学习报告 </p>
					<p class="font1" style="font-size: 41px;margin-top: 27px;color: #e06c24;"> 坚持学习的人永葆青春 </p>
				
					<div v-show="!Loading" class="input-container" style="margin-top: 4vh">
					<input v-model="jobNo" type="text" id="input" required="" />
					<label for="input" class="label">请输入工号</label>
					<div class="underline"></div>
					</div>
					<div v-show="!Loading" style="display: flex; justify-content: center;margin-top:40px;">
					<button class="button" @click="inputJobNo()">NEXT</button>
					</div>
					<!-- <LoadingAuguest v-show="Loading" style="margin-top: 30vh" /> -->
				</div>
			</div>
        </transition>
        <main v-if="reportData && reportData.studate != 0" id="main" ref="scrollDiv" class="view">
			<section id="section01" class="section">
				<!-- 有学习天数，有学分 -->
				<div v-if="reportData.studate > 0 && reportData.creditvalue > 0" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 100%; margin-top: 10vh">
						<p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
						<p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">上半年</span></p>

						<p class="font1" style="font-size: 30px;margin-top: 15px;">你已经学习了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span>天</p>
						<p class="font1" style="font-size: 30px;margin-top: 15px;">累计学习了<span class="font2" style="font-size: 32px;">{{ reportData.playtime }}</span >小时</p>

						<p class="font1" style="font-size: 30px;margin-top: 15px;">学习了<span class="font2" style="font-size: 32px;">{{ reportData.coursenumMon }}</span >门课程</p>
						<p class="font1" style="font-size: 36px;text-align: center;margin-top: 45px;">完成了<span class="font2" style="font-size: 32px;">{{ reportData.coursenum }}</span >门课程</p>

						<p class="font1" style="font-size: 30px;margin-top: 15px;">累计考试<span class="font2" style="font-size: 32px;">{{ reportData.examTimes }}</span >次</p>
						<p class="font1" style="font-size: 36px;text-align: center;margin-top: 45px;">获得学分<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >分</p>
					</div>
				</div>

				<!-- 有学习天数，没有学分 -->
				<div v-if="reportData.studate > 0 && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 100%; margin-top: 10vh">
						<p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
						<p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">上半年</span></p>

						<p class="font1" style="font-size: 30px;margin-top: 15px;">你在富学宝典平台上的总学习天数达到了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span >天</p>
						<p class="font1" style="font-size: 30px;margin-top: 15px;">但是还没有获得学分，请继续加油！</p>
						<p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
					</div>
				</div>

				<!-- 没有学习天数，没有学分 -->
				<div v-if="!reportData.studate && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 100%; margin-top: 20vh">
						<p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
						<p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">上半年</span></p>

						<p class="font1" style="font-size: 30px;margin-top: 15px;">你还没有在富学宝典上学习，请继续加油！</p>
						<p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
					</div>
				</div>
			</section>

			<section id="section02" class="section">
				<div class="page2" style="display: flex; flex-wrap: wrap">
					<div class="right" style="width: 100%; margin-top: 10vh">
						<p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">勤勉进取，卓尔不群</p>
						<!-- <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">不见其增，日有所长。</p> -->

						<p  style="text-align: center;font-weight: 700;color: black; font-size: 30px;margin-top: 21px;">2024年富学宝典上热门课程推荐：</p>
						<div v-for="(item,index) in mergeBook.slice(0,3)" :key="index" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
							<p @click="redirectToBook(index)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" ></i></p>
						</div>

						<p  v-if="uncompletedLink !==null"  style="text-align: center;font-weight: 700;color: #000; font-size: 30px;margin-top: 21px;">以下课程已学习过半，您离完成目标只差一步之遥：</p>
						<div  v-for="(item,index) in mergeBook.slice(3)" :key="index+3" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
							<p @click="redirectToBook(index+3)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" ></i></p>
						</div>
					</div>
				</div>
			</section>

			<section id="section03" class="section">
				<div style="display: flex; flex-wrap: wrap">
					<div class="right" style="width: 100%; margin-top: 10vh">
						<p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">持续进步，学无止境</p>
						<!-- <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">积学成才道路赊。</p> -->
						<!-- <div>
							<p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">2024年必修课程：</p>
							<ul style="margin: 0 auto; font-size: 30px;color: #000;;text-align: center;margin-top: 3vh;">
							<li>{{ coc[0].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[0].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
							<li>{{ coc[1].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[1].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
							</ul>
							<p style="width: 100%;margin: 0 auto;font-size: 15px;color: #000;margin-top: 3vh;text-align: center;">**具体可登录富学宝典查看:【首页】>【个人设置】>【学习任务】**</p>
						</div> -->
						<div>
							<p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">EHS+ESG 6月主题课程推荐：</p>
							<ul style="margin: 0 auto; font-size: 30px;color: #000;;text-align: center;margin-top: 3vh;">
							<ul v-for="(item,index) in themeLink" :key="index" ref="">
								<a :href="item.link" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">{{ item.Name }}</li></a>
							</ul>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="section04" class="section">
				<div class="page4"  style="display: flex; flex-wrap: wrap">
					<div class="title"><p class="font1" style="font-size: 60px;">好书推荐</p></div>
						<div class="left" style="margin-top: 40px;width: 80%;margin: 0 auto;">
							<div class="detail">
								<p style="text-align: center;font-size: 30px;color: #000;">《宽容》</p>
								<p class="font2" style="font-size: 18px;text-align: center;">亨德里克·威廉·房龙</p>
							</div>
							<div class="bookDetail" style="font-size: 17px;padding: 20px;color: #000;">
								<span style="font-size: 20px;">
								《宽容》是一部描述人类思想解放的历程，畅销近百年的通俗历史读本，是关于宽容和自由思想的人文主义经典之作。<br><br>  
								房龙从人文主义的立场出发，站在全人类的高度，借助“宽容”之眼，重新审视人类由史前时代，古希腊、古罗马时代、中世纪、文艺复兴时代到现代几千年文明的变迁和人类寻求自身解放的漫长历程，这期间，善于恶、黑暗与光明、进步与反动的不断搏杀，勾勒出一幅波澜壮阔的历史画卷。<br><br>  
								房龙的著作语言优美、知识广博、幽默风趣、发人深省，贯穿着理性、宽容和进步的人文主义思想，具有经久不衰的魅力。<br><br>  
								</span>
							</div>
						</div>
						<div class="right" style="margin-top: 40px;width: 80%;margin: 0 auto;">
							<div class="detail">
								<p style="text-align: center;font-size: 30px;color: #000;">《斯坦福高效睡眠法》</p>
								<p class="font2" style="font-size: 18px;text-align: center;">[日]西野精治</p>
							</div>
							<div class="bookDetail" style="font-size: 17px;padding: 20px;">
								<span style="font-size: 20px;text-align: justify;color:#000;">
									《中国睡眠研究报告（2023）》显示，2022年我国居民睡眠指数为67.8（百分制），受访者每晚平均睡眠时长为7.4小时，近半数受访者每晚平均睡眠时长不足8小时，16.79%的受访者每晚平均睡眠时长不足7小时，其中17-26岁的受访者的睡眠质量自评最差。<br><br>
									报告指出，工作或学习压力是影响睡眠质量的最重要因素。<br><br>
									本书主要解决睡眠、睡眠不足、睡醒后仍然感觉很疲惫等困扰大家的问题。<br><br>
									三个步骤，带你远离失眠困扰，十大功率，教你安心睡个好觉！<br><br>
								</span>
							</div>
						</div>         
				</div>
			</section>

			<section id="section05" class="section">
				<div class="page5" style="position: relative;top: 10vh;">
						<div style="margin: 0 auto;margin-top: 10vh">
							<p class="font2" style="font-size: 30px; text-align: center;">心怀梦想，勇敢追求</p>
							<p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">每一个愿望，都是你对未来的期许。</p>
							<p class="font1" style="font-size: 30px; text-align: center;">你希望在富学宝典平台上遇见哪些好课程呢?</p>
							<p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">请写下你的学习清单吧！</p>
							<form id="form" class="topBefore">
								<textarea id="message" v-model="comment" type="text" placeholder="MESSAGE"></textarea>
								<input id="submit"  @click="submit" type="button" value="OK!" />
							</form>
						</div>
						<div style="padding-top: 70px;margin: 0 auto;">
							<p style="font-size: 48px;text-align: center;color: #000;">THANK YOU!</p>
							<p class="font1" style="font-size: 48px;text-align: center;">一旦决心学习，谁也拦不住你</p>
						</div>
				</div>
			</section>
        </main>
    </div>
</template>

<script>
import Loading from './Loading.vue'
import viewApi from "@/api/view";
import dataApi from "@/api/data";
import { getArray } from "../../utils/encourage";
export default {
    data(){
      	return{
			viewId: "",
			Loading:false,
			reportData:'',
			jobNo:'',
			comment: "",
			source: "",

			recommendBook:'',
			uncompletedLink:'',
			mergeBook:'',
			coc:'',
			themeLink:''
		}
    },
    created(){
		document.title = "半年度学习报告";
		/* 相信数据begin */
		var test = window.location.href
		let arr = test.split("?code=")
		this.code = arr[1]
		if (this.code) {
			viewApi.getJobNoByBelieve(this.code).then((res) => {
				if(res.data.code === 200) {
					this.jobNo = res.data.data.jobNo
					this.source = "相信"
					if (this.jobNo) {
					this.Loading = true;
					this.getData()
					}
				}
			})
		}
      	/* 相信数据end */
    },
    methods:{
		submit() {
		if (!this.comment) {
			this.$message({
				message: "请说说您的学习计划",
				type: "warning",
				center: true,
			});
		} else if (this.comment) {
			const view = {
				comment: this.comment,
				studyList: this.studyList,
			};
			view["id"] = this.viewId;
			// console.log(view);
			viewApi.update(view).then((res) => {
				if (res) {
					this.$message({
						message: "提交成功，感谢您的留言。",
						type: "success",
						center: true,
					});
				}
			});
		}
		},
		inputJobNo() {
				if (this.Loading === true) {
					return;
				}
				if (this.jobNo) {
					this.Loading = true;
					this.getData();
				} else {
					this.$message({
						message: "请输入工号",
						type: "warning",
						center: true,
					});
				}
		},
		getData() {
				dataApi.getDataFor24June(this.jobNo).then((res) => {
					this.reportData = res.data.data.data;
					// console.log(res.data.data.data);

					this.recommendBook=JSON.parse(this.reportData.topRecommendLink)
					this.uncompletedLink=JSON.parse(this.reportData.uncompletedLink)
					this.mergeBook=this.recommendBook.concat(this.uncompletedLink)
					// this.coc=JSON.parse(this.reportData.coc)
					this.themeLink=JSON.parse(this.reportData.themeLink)
					if (this.reportData) {
						this.sendViewRecords();
						// this.Loading = false;
						this.reportData.textLab = getArray(this.reportData.textLab);
					} else if (!this.reportData) {
						this.$message({
							message: "抱歉，暂时找不到您的学习报告！",
							type: "warning",
							center: true,
						});
						this.Loading = false;
					}
				});
		},
		sendViewRecords() {
			if (this.jobNo) {
				let viewData = {
					jobNo: this.jobNo,
					device: "PC",
					type: 19,
					browser: this.browser,
				};
				if (this.source) {
					viewData["source"] = this.source;
				}
				viewApi.view(viewData).then((res) => {
					this.viewId = res.data.data.data.id;
				});
			} else {
				return;
			}
		},
		redirectToBook(id){
			const book=this.mergeBook[id]
			const view={
				clickCourseName:book.Name,
				clickCourseLink:book.link
			}
			view["id"] = this.viewId;
			viewApi.update(view).then((res) => {
				if (res.data.code===200) {
					window.location.href = view.clickCourseLink;
				}
			});
		}
    },
    mounted(){
     
    }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* 字体样式 */
.font1{
  color:rgb(36, 35, 35); 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
  text-align: center;
}
.font2{
  color: #e06c24; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
}

.font3{
  color: #e06c24; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  text-align: center;
}
/* 第一页 */
.body {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

.zhezhao {
  width: 100vw;
  height: 100vh;
  /* background-image: linear-gradient(170deg, #b55d7f , #953b5d); */
  background:url("../../assets/24June/pcbg.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
}
.input-container {
  position: relative;
  margin: 50px auto;
  width: 400px;
}

.input-container input[type="text"] {
  font-size: 20px;
  width: 100%;
  border: none;
  border-bottom: 2px solid #000;
  padding: 5px 0;
  background-color: transparent;
  outline: none;
  color: #e06c24;
}

.input-container .label {
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  transition: all 0.3s ease;
  pointer-events: none;
}

.input-container input[type="text"]:focus ~ .label,
.input-container input[type="text"]:valid ~ .label {
  top: -20px;
  font-size: 16px;
  color: #e06c24;
}

.input-container .underline {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #e06c24;
  transform: scaleX(0);
  transition: all 0.3s ease;
}

.input-container input[type="text"]:focus ~ .underline,
.input-container input[type="text"]:valid ~ .underline {
  transform: scaleX(1);
}
.button {
  --bg: #e06c24;
  --text-color: #e06c24
  position: relative;
  width: 150px;
  height: 40px;
  border: none;
  background: var(--bg);
  color: var(--text-color);
  padding: 1em;
  font-weight: bold;
  text-transform: uppercase;
  transition: 0.2s;
  border-radius: 5px;
  opacity: 0.8;
  letter-spacing: 1px;
  box-shadow: #da9164 0px 7px 2px, #000 0px 8px 5px;
}

.button:hover {
  opacity: 1;
}

.button:active {
  top: 4px;
  box-shadow: #e06c24 0px 3px 2px, #000 0px 3px 5px;
}

/* 第二页 */
.view {
  width: 100%;
  height: 100%;
  background:url("../../assets/24June/pcbg.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  /* background-image: linear-gradient(170deg, #7a94ac , #a2bed8); */
}
main {
  scroll-snap-type: y mandatory;
  scroll-padding: 80px;
  overflow: scroll;
  height: 100vh;
}
section {
  width: 100vw;
  height: 100vh;
  scroll-snap-align: start;
}
#section01,#section02,#section03,#section04{
  position: relative;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #fff;
    text-align: center;
}
li {
    align-items: center;
    margin-bottom: 8px; 
}

/* li::before {
    content: '\2022'; 
    color: #fff;
    font-size: 1.5em;
    margin-right: 3px; 
    margin: 0 auto;
} */

/*书籍推荐页 */
.title {
  font-size: 50px;
  width: 100%;
  margin-bottom: 30px;
  margin-top: 30px;
}


/* 最后的输入框 */
#form {
  position: relative;
  width: 40vw;
  padding-top: 50px;
  margin: 0 auto;
}

input {
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  width: 570px;
  height: 50px;
  padding: 0px 15px 0px 15px;
  background: transparent;
  outline: none;
  color: #000;
  border: solid 1px #fff;
  border-bottom: none;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

input:hover {
  background: #fff;
  color: #000;
}

textarea {
  width: 40vw;
  max-width: 40vw;
  height: 20vh;
  max-height: 20vh;
  padding: 0;
  background: transparent;
  outline: none;
  color: #000;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  border: solid 1px #36854f;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

/* textarea:hover {
  background: #e89fbb;
  color: #fff;
} */

#submit {
  width:  40vw;
  padding: 0;
  margin: -5px 0px 0px 0px;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  color: #000;
  outline: none;
  cursor: pointer;
  border: solid 1px #36854f;
  border-top: none;
}

#submit:hover {
  color: #b3aca7;
}
/* 

*/
</style>